import { SettingsConfig } from "../../../index";

interface FormTemplateConstructorProps {
	id: string;
	name: string;
	status: FormStatus;
	settingsConfig: SettingsConfig[];
}

class FormTemplate {
	constructor(public _: FormTemplateConstructorProps) {}

	toJson = () => {
		return {
			id: this._.id,
			name: this._.name,
			status: this._.status,
			settingsConfig: this._.settingsConfig.map((config) => config.toJson()),
		};
	};

	static fromJson = (json: any) => {
		return new FormTemplate({
			id: json.id,
			name: json.name,
			status: json.status,
			settingsConfig: json.settingsConfig.map((config: any) =>
				SettingsConfig.fromJson(config)
			),
		});
	};
}

enum FormStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
}

export { FormTemplate, FormStatus };
